import React, { PropsWithChildren } from 'react';

import * as S from './Overlay.style';

export const ModalOverlay: React.FC<PropsWithChildren> = ({ children }) => {
  return <S.Container>{children}</S.Container>;
};
